export const getDiscussionsList = state => state.discussionList.get('discussions');
export const getDiscussionIsLoaded = (state, discussionId) => state.discussionList.getIn(['discussions', discussionId]);
export const getDiscussionUnreadMessageCount = (state, discussionId) => state.discussionList.getIn(['discussions', discussionId, 'unreadMessageCount']);



/** WEBPACK FOOTER **
 ** ./src/selectors/discussion-list-selectors.js
 **/